import { useSyncExternalStore } from 'react';
import { noop, constant } from 'lodash-es';

export const useIsFramed = () => {
  return useSyncExternalStore(
    noop,
    () => {
      let isFramed = false;
      try {
        if (window.self !== window.top) {
          isFramed = true;
        }
      } catch {
        isFramed = true;
      }

      return isFramed;
    },
    constant(false)
  );
};
